module.exports = __webpack_public_path__ + "static/cloud3-779c329f5ad9fe2fb90647a93e7b1ed2.png";